/*!
=========================================================
* 支払依頼（駐車場）登録
=========================================================
*/
import React from "react";

import {
  Button,
  Card,  CardHeader,  CardTitle,
  Table,  Row,  Col, Container,
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import { Link } from "react-router-dom";
import ButtonWithTooltip from '../../FormParts/ButtonWithTooltip';
import InputText from '../../FormParts/InputText'
import InputNumber from '../../FormParts/InputNumber'
import InputSelect from '../../FormParts/InputSelect'
import InputRadio from '../../FormParts/InputRadio'
import InputDatetime from '../../FormParts/InputDatetime'
import Request from '../../../common/Request';
import Format from '../../../common/Format';
import FormatCode from '../../../common/FormatCode';
import CustomTd from '../../ViewParts/CustomTd';
import SummationSelectPopup from '../../ViewParts/SummationSelectPopup';
import _ from 'underscore';
import {
  cst_payment_type,
  cst_payment_bank_account_type,
  cst_supplier_bank_account_type,
  ORDER_BOX_STATUS
} from '../../../variables/codes_map';
import Definition from '../../../common/Definition'
import GsuiteAuth from '../../../components/Auth/GsuiteAuth';
import WithRole from '../../FormParts/ButtonWithRole';
import { GetMessage } from '../../../variables/message';

var domain = "";  

class List extends React.Component {

  constructor(props){
    super(props);
    this.state ={
        paymentEditIndex: undefined,
        bankList:[],
        bankBranchList:[],
        regist_modal: false,
        sub_regist_modal: false,
        error_modal: false,
        view: false,
        pdata:[],
        sdata:{},
        error:true,
        paymentData:{
          values:{
            payment_bank: "",
            payment_bank_branch: "",
            payment_bank_account_kana: "",
            payment_bank_account_type: "",
            payment_bank_account_number: "",
            payment_amt: 0,
            payment_type : cst_payment_type[0].default
          },
          errors:{
            bank:GetMessage(2545),
          },
          requiredData:{
            bank:GetMessage(2545),
          }
        },
        data:{
          values:{},
          errors:{},
          requiredData:{},
        },
        request_data:{},
        supplierBankList: [],
        // adjustment_flag: false,
    };

    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleSubRegistModal = this.toggleSubRegistModal.bind(this);
    this.summationSelected = this.summationSelected.bind(this);
    this.summationRemove = this.summationRemove.bind(this);
    this.paymentSelected = this.paymentSelected.bind(this);
    this.paymentRemove = this.paymentRemove.bind(this);
    this.summation_select_popup = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
    this.summation_list = this.summation_list.bind(this)
    this.payment_list = this.payment_list.bind(this)
    this.regist = this.regist.bind(this)
    this.paymentEdit = this.paymentEdit.bind(this)
    this.supplierBankOptions = this.supplierBankOptions.bind(this)
    this.cellsSupplierBanks = this.cellsSupplierBanks.bind(this)
    this.customFields = this.customFields.bind(this)
    this.loadData = this.loadData.bind(this);
  } 

  // 初期ロード用
  componentDidMount(){
    this.loadData();
  }
  loadData(tmp_pdata=undefined){
   if (this.props.match.params.estimate_seq != undefined ) {
      const paymentUrl = '/api/payment'
      const paymentPatams = {
        estimate_natural_id_ssv: this.props.match.params.estimate_seq,
        payment_status:["0","1","2","3","4","5"],
        detail_flag: true
      }
      Request.get(paymentUrl, paymentPatams,
        async paymentResponse => {
          // console.log('paymentResponse', paymentResponse)
          const paymentData = paymentResponse.Data
          if (paymentData.length>0){
            const estimate_natural_id_ssv = paymentResponse.Data.length>0 && paymentResponse.Data[0].estimate_natural_id_ssv
            const estimateNaturalIds = estimate_natural_id_ssv && estimate_natural_id_ssv.split(',')
            
            const estimateData = estimateNaturalIds && estimateNaturalIds.length>0 
              && estimateNaturalIds.map((estimateNaturalIds)=>{
                const estimateUrl = '/api/requestpayment/parking';
                return new Promise((resolve,reject)=>{
                  Request.get(estimateUrl, {
                    estimate_natural_id: estimateNaturalIds,
                    payment_request_status : "0,1,2,5",
                    detail_flag: true
                  }, res => resolve(res.Data[0]), ()=>reject())
                })
              })
            
            const estimates = (await Promise.all(estimateData).then(resolve=>resolve)).filter(estimate=>estimate) || []

            // console.log(estimates)
            
            if (estimates.length<1){
              this.props.pageChangeAlert.current.inactivate();
              this.props.history.push('/forbidden')
              return
            }

            if(estimates[0] && estimates[0].payment_request_status == 1 || estimates[0] && estimates[0].payment_request_status == 5){
              this.props.pageChangeAlert.current.inactivate();
              this.props.alertModal.current.confirmCheck({
                title:'処理完了',
                messageNo:2446
              },()=>this.props.history.push('/construction/list'),false)
            }
              
            const request_data = estimates.length>0 && estimates[0] && await new Promise((resolve)=>{
              Request.get('/api/request', {
                request_natural_id: estimates[0].request_natural_id,
                all_survey_status: true
              }, requestRes=>{
                resolve(requestRes.Data[0])
              })
            })

            const supplier_banks = estimates.length>0 && await new Promise((resolve)=>{
              Request.get('/api/supplier/bank',
                {supplier_id: estimates.map(e=>{return e.supplier_id}).join(",") },
                resSupplier=>{
                  resolve(resSupplier.Data)
                });
            });
            // console.log(supplier_banks);

            this.setState({
                sdata:estimates.reduce((acc, estimate)=>{
                  if (estimate){
                    acc[estimate.ulid] = estimate
                  }
                  return acc
                },{}),
                pdata:tmp_pdata ? tmp_pdata : paymentData,
                request_data,
                view:paymentData.length>0?true:false,
                supplierBankList : [...supplier_banks]
              });
          } else {
            const url = domain + '/api/requestpayment/parking';
            const params = {
              estimate_natural_id: this.props.match.params.estimate_seq,
              payment_request_status : "0,1,2,5",
              detail_flag: true
            }; 
            Request.get(url, params,
              res => {
                if(res.Data.length > 0){
                  const request_natural_id = (res.Data[0].request_natural_id)
                    console.log(res.Data[0].payment_request_status)
                  if(res.Data[0].payment_request_status == 1 ||res.Data[0].payment_request_status == 5 ){
                    this.props.pageChangeAlert.current.inactivate();
                    this.props.alertModal.current.confirmCheck({
                      messageNo:2446
                    },()=>this.props.history.push('/construction/list'),false)
                  }

                  Request.get('/api/request', {
                    request_natural_id,
                    all_survey_status: true
                  }, requestRes=>{
                    this.setState({
                      sdata:{[res.Data[0].ulid]:res.Data[0]},
                      request_data:requestRes.Data[0]
                    });
                  })

                  // 2022-07-23
                  Request.get('/api/supplier/bank',
                      {supplier_id: res.Data.map(e=>{return e.supplier_id}).join(",")},
                      resSupplier=>{
                        console.log(resSupplier);
                        this.setState({
                          supplierBankList : [...resSupplier.Data]
                        });
                    });

                } else {
                  this.props.pageChangeAlert.current.inactivate();
                  this.props.history.push('/forbidden')
                  return
                }
              });
          }
          
        }
      )
      // TO DO :: change payment & estimate addition to work with object
    }

    Request.get('/api/bank', {}, res=>{
      this.setState({
        bankList:res.Data.map(element=>{
          return {
            value:element.bank_natural_id,
            label:element.bank_name
          }
        })
      });
    })
    Request.get('/api/bank/branch', {}, res=>{
      this.setState({
        bankBranchList:res.Data.map(element=>{
          return {
            value:element.bank_branch_natural_id,
            label:element.bank_branch_name,
            bank_natural_id:element.bank_natural_id
          }
        })
      });
    })
  }


  summationSelected(estimate) {
    
    // if (estimate && estimate.survey_parking_address_contract) {
      this.setState({
        sdata: {
          ...this.state.sdata,
          [estimate.ulid]:estimate
        }
      });
    // } else {
    //   this.props.alertModal.current.showErrorModal({messageNo:2445})
    // }
  }

  summationRemove(key){
    this.props.alertModal.current.confirmCheck({messageNo:2411},()=>{
      this.setState({
        sdata: Object.keys(this.state.sdata).reduce((acc,keyName)=>{
            if (key!==keyName) {
              acc[keyName] = this.state.sdata[keyName]
            }
            return acc
          },{})
      });
    })
  }

  validateCallback(newData, callback=()=>{}){

    // console.log(newData,this.state.paymentData);

    let errors = newData.errors;

    if ( newData.values.bank && newData.values.bank != this.state.paymentData.values.bank ) {
      
      let supplierBank = this.state.supplierBankList.filter(b=>b.id == newData.values.bank)[0]
      
      let old_errors = this.state.paymentData.errors;
      errors = {
        ...old_errors
      }
      delete errors["bank"];
      
//      console.log(supplierBank,this.state.supplierBankList);

      this.setState({
        paymentData:{
          ...this.state.paymentData,
          values:{
            ...this.state.paymentData.values,
            ...newData.values,
            supplier_bank_id : supplierBank.id,
            bank_natural_id : supplierBank.bank_natural_id,
            bank_branch_natural_id : supplierBank.bank_branch_natural_id,
            payment_bank : supplierBank.supplier_bank,
            payment_bank_branch : supplierBank.supplier_bank_branch,
            payment_bank_account_kana : supplierBank.supplier_bank_account_kana,
            payment_bank_account_type : supplierBank.supplier_bank_account_type,
            payment_bank_account_number : supplierBank.supplier_bank_account_number
          },
          errors:errors
        }
      },()=>{
//        console.log(this.state.paymentData);
      });
    }
    else {
      let supplierBank = {};
      let tmpData = {...this.state.paymentData,
                     ...newData,
                    values:{
                      ...this.state.paymentData.values,
                      ...newData.values,
                    }
                  };
      
      if(tmpData.values.payment_type=="0"){
        if(tmpData.values.bank == null || tmpData.values.bank == ""){
          errors.bank = GetMessage(2545);
        }else{
          supplierBank = this.state.supplierBankList.filter(b=>b.id == tmpData.values.bank)[0]
          // console.log(newData);
          errors = newData.values.payment_user_memo != "" && this.state.paymentData.errors.payment_user_memo ? this.state.paymentData.errors : errors; 
        }
      }else{
        if(errors.bank != undefined){
          delete errors["bank"];
        }
      }
      // console.log(newData,tmpData,this.state.paymentData);
      this.setState({
        paymentData:{
          ...tmpData,
          values:{
            ...tmpData.values,
            bank : tmpData.values.payment_type=="0" ? tmpData.values.bank : null,
            supplier_bank_id : supplierBank.id != undefined ? supplierBank.id : null,
            bank_natural_id : supplierBank.bank_natural_id != undefined ? supplierBank.bank_natural_id : null,
            bank_branch_natural_id : supplierBank.bank_branch_natural_id != undefined ? supplierBank.bank_branch_natural_id : null,
            payment_bank : supplierBank.supplier_bank != undefined ? supplierBank.supplier_bank : null,
            payment_bank_branch : supplierBank.supplier_bank_branch != undefined ? supplierBank.supplier_bank_branch : null,
            payment_bank_account_kana : supplierBank.supplier_bank_account_kana != undefined ? supplierBank.supplier_bank_account_kana : null,
            payment_bank_account_type : supplierBank.supplier_bank_account_type != undefined ? supplierBank.supplier_bank_account_type : null,
            payment_bank_account_number : supplierBank.supplier_bank_account_number != undefined ? supplierBank.supplier_bank_account_number : null,            
          },
          errors:errors
        }
      }, ()=>{
      //  console.log(this.state.paymentData);
      })
    }
  }

  paymentSelected() {
    if (Object.keys(this.state.paymentData.errors).length===0){
      const {
        paymentEditIndex,
        pdata,
      } = this.state
      let { values } = this.state.paymentData;

      if(values.payment_type != "0"){
        values = {
          ...values,
          bank_natural_id: null,
          bank_branch_natural_id: null,
          payment_bank: null,
          payment_bank_branch: null,
          payment_bank_account_kana: null,
          payment_bank_account_type: null,
          payment_bank_account_number: null,
        }
      }
      values.bank_natural_id = values.bank_natural_id === values.payment_bank? undefined : values.bank_natural_id
      values.bank_branch_natural_id = values.bank_branch_natural_id === values.payment_bank_branch? undefined : values.bank_branch_natural_id
      this.setState({
        ...(
          paymentEditIndex===undefined
          ? {pdata: [...pdata, values]}
          : {pdata: [...pdata.map((payment, index)=>{
            return paymentEditIndex!==index?payment:values
          })]}
        ),
        paymentData:{
          values:{
            payment_bank: "",
            payment_bank_branch: "",
            payment_bank_account_kana: "",
            payment_bank_account_type: "",
            payment_bank_account_number: "",
            payment_type: "0",
            payment_amt: 0
          },
          errors:{
            bank:GetMessage(2545),
          },
          requiredData:this.state.paymentData.requiredData
        },
        paymentEditIndex:paymentEditIndex!==undefined?undefined:paymentEditIndex
      });
    } else {
      this.props.alertModal.current.showErrorModal({messageNo:2401})
    }
  }

  paymentRemove(key){
    this.props.alertModal.current.confirmCheck({messageNo:2411},()=>{
      if(key !== undefined){
        this.setState({
          pdata: this.state.pdata.filter((element,index)=>index!==key)
        });
      }
    })
  }

  toggleRegistModal(reset=false) {
    if (reset) {
      this.setState({
        regist_modal: !this.state.regist_modal,
        paymentEditIndex : undefined,
        paymentData:{
          values:{
            payment_bank: "",
            payment_bank_branch: "",
            payment_bank_account_kana: "",
            payment_bank_account_type: "",
            payment_bank_account_number: "",
            payment_amt: 0,
            payment_type : cst_payment_type[0].default,
            payment_user_memo: Object.keys(this.state.sdata).length>0 && this.state.sdata[Object.keys(this.state.sdata)[0]].order_memo
          },
          errors:{bank:GetMessage(2545)},
          requiredData:{bank:GetMessage(2545)}
        },
      });
    } else {
      this.setState({
        regist_modal: !this.state.regist_modal,
      })
    }
  }

  toggleSubRegistModal(){
    if(this.props.match.params.construction_id != undefined){
      return null;
    }else{
      this.setState({
        sub_regist_modal: !this.state.sub_regist_modal
      });
    }
  }

  regist() {
    const estimate_natural_id_ssv = Object.keys(this.state.sdata).map((estimateUlid)=>this.state.sdata[estimateUlid].estimate_natural_id).join(',')
    const estimates = Object.keys(this.state.sdata).map((estimateUlid)=>{
      console.log(this.state.sdata[estimateUlid])
      return {
        estimate_natural_id: this.state.sdata[estimateUlid].estimate_natural_id,
        update_timestamp: this.state.sdata[estimateUlid].update_timestamp,
        // 更新時は受注BOXステータスは変更しない、登録時は4:チェックに設定
        // #2509対応 2025/11/10 対応 3:仕入なら4:チェックに設定を追加
        order_box_status: this.state.view ? this.state.sdata[estimateUlid].order_box_status == ORDER_BOX_STATUS.PURCHASE ? ORDER_BOX_STATUS.CHECK: undefined : ORDER_BOX_STATUS.CHECK
      }
    })
    const {
      user_branch_id,
      user_branch_natural_id
    } = this.state.sdata[Object.keys(this.state.sdata)[0]]
    const params = this.state.pdata.map((payment)=>{
      return {
        ...payment,
        user_branch_id, //:GsuiteAuth.get('user_branch_id'),
        user_branch_natural_id, //:GsuiteAuth.get('user_branch_natural_id'),
        estimates,
        estimate_natural_id_ssv
      }
    })

    const errorModal = (err) => {
      console.log("payment failed:", err);
      Request.setProgress(0);
      this.props.alertModal.current.confirmCheck({
        title: "エラーが発生しました。",
        message: err.Data.error ? err.Data.error : err.Message ? err.Message : "処理中にエラーが発生しました。",
        closeBtn: false,
        titleBtn: "閉じる"
      }, ()=>{
        this.loadData(this.state.pdata)
      }, false)
   }

    if (this.state.view) {
      // put update
      Request.put('/api/requestpayment/parking/update', {estimates : estimates, payments : params}, res => {
        console.log(res)
        this.props.pageChangeAlert.current.inactivate()
        this.toggleSubRegistModal();
        document.body.style.overflow = "auto";
        if(res.Code!=200){
          errorModal(res)
          return ;
        }
        this.props.history.push(this.props.location.transition_source);
      });
    } else {
      // post regist
      Request.post('/api/requestpayment/parking', {estimates : estimates, payments : params}, res => {
        console.log(res)
        this.props.pageChangeAlert.current.inactivate();
        this.toggleSubRegistModal();
        document.body.style.overflow = "auto";
        if (res.Code != 200) {
          errorModal(res)
          return ;
        }
        this.props.history.push(this.props.location.transition_source); 
      });
    }

  }

  summation_list({data = {}, index, keyName}){
    const {
      estimate_natural_id,
      site_name,
      construction_number,
      supplier_ulid
    } = data
    const align={
      verticalAlign: "top",
      textAlign: "left"
    }
    const supplier_bank_url = "/supplier/detail/" + supplier_ulid
    return (
      <>
      <tr className="table-link" key={index}>
        <td style={align}>{estimate_natural_id}</td>
        <td style={align}>{site_name}</td>
        <td style={align}>{construction_number}</td>
        <td style={align}><span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', data)}} /></td>
        <td style={align}><span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_use_parking', data)}} /></td>
        <td style={align}><span dangerouslySetInnerHTML={{__html:Format.comma_delimited(Definition.item('___SUM_all_amt', data),"円")}} /></td>
        <td>
          <button disabled={index == 0 || this.state.view} type="button" className="btn btn-sm" data-dismiss="modal" aria-label="Close" onClick={() => {this.summationRemove(keyName)}}>
          削除
          </button>
        </td>
        <td>
          <button type="button" className="btn btn-sm" data-dismiss="modal" aria-label="Close" onClick={()=>{window.open(supplier_bank_url)}}>口座情報登録</button>
        </td>
      </tr>                            
      </>
    );
  }

  payment_list({data={},index}){
    const {
      payment_bank_account_kana,
      payment_type,
      payment_amt,
      id,
      payment_status,
      payment_limit_date,
      payment_request_memo
    } = data
    const align={
      verticalAlign: "top",
      textAlign: "left"
    }

    return (
      <>
      <tr key={index}>
        <td  style={align}>
          <span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_payment_bank_name', data)}} /><br />
          <span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_payment_bank_detail', data)}} /><br />
          {payment_bank_account_kana}
        </td>
        <td style={align}>{FormatCode.decode("cst_payment_type", payment_type)}</td>
        <td style={align}>{Format.format_date(payment_limit_date)}</td>
        <td style={align}>{Format.comma_delimited(payment_amt,"円")}</td>
        <td style={align}>{payment_status===undefined || payment_status===0 ? "新規" : FormatCode.decode("cst_payment_status", payment_status)}</td>
        <td style={align}>{payment_request_memo}</td>
        <td>
          <button disabled={payment_status === undefined  || payment_status===0 ? false : payment_status != "2"} type="button" className="btn btn-sm" data-dismiss="modal" aria-label="Close" onClick={() => {this.paymentEdit(index)}}>
          編集
          </button>
          <button disabled={this.state.view && id} type="button" className="btn btn-sm" data-dismiss="modal" aria-label="Close" onClick={() => {this.paymentRemove(index)}}>
          削除
          </button>
        </td>
      </tr>
      </>
    );
  }

  paymentEdit(index){
    this.setState({
      paymentEditIndex:index,
      paymentData:{
        values:{
          ...this.state.paymentData.values,
          ...this.state.pdata[index],
          bank_natural_id : this.state.pdata[index].bank_natural_id || this.state.pdata[index].payment_bank,
          bank_branch_natural_id : this.state.pdata[index].bank_branch_natural_id || this.state.pdata[index].payment_bank_branch
        },
        errors:{}
      },
      regist_modal: !this.state.regist_modal
    });
  }

  render() {
    const SummationList = this.summation_list
    const PaymentList = this.payment_list
    const ___SUM_payment_amt = Definition.item('___SUM_payment_amt', this.state.pdata)
    const ___SUM_total_amt = Definition.item('___SUM_total_amt', Object.keys(this.state.sdata).map(keyName=>this.state.sdata[keyName]))
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.request_data)

    return (
      <>
        <div className="content">
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h3" className="float-left">{`仕入依頼（駐車場）${this.state.view?"更新":"登録"}`}</CardTitle>
              </CardHeader>
              <Col md="11"  className="detail">
                <Table>
                  <tbody>
                    <tr>
                      <th>仕入対象見積合計</th>
                      <th className="sub">支払合計</th>
                    </tr>
                    <tr>
                      <td>
                        {Format.comma_delimited(___SUM_total_amt,"円")}
                      </td>
                      <td>
                        {Format.comma_delimited(___SUM_payment_amt,"円")}
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <Row>
                  <Col md="6">
                      <CardTitle tag="h4" className="float-left">仕入対象見積</CardTitle>
                  </Col>
                </Row>
                <Row>
                <Col md="12" className="detail-table-wrapper">
                  <Table>
                    <tbody>
                      <tr>
                          <th>見積ID</th>
                          <th>現場名</th>
                          <th>工事番号</th>
                          <th>顧客情報</th>
                          <th>仕入情報</th>
                          <th>仕入値</th>
                          <th>削除</th>
                          {/** 口座情報追加　暫定対応 */}
                          <th></th>
                      </tr>
                      {Object.keys(this.state.sdata).length>0 && Object.keys(this.state.sdata).map((keyName,index)=> {
                        const data = this.state.sdata[keyName]
                        return <SummationList data={data} index={index} key={index} keyName={keyName}/>
                      })}
                    </tbody>
                  </Table>
                </Col>
                </Row>
                <Row>
                  <Col md="6">
                      <CardTitle tag="h4" className="float-left sub">支払先情報</CardTitle>
                  </Col>
                  <Col md="6">
                      <ButtonWithTooltip onclick={() => { this.toggleRegistModal(true); }} class="btn-search btn-facebook float-right" id="tmp" icon="fas fa-plus" label="追加" message="支払先情報を追加します。" />
                  </Col>
                </Row>
                <Row>
                <Col md="12" className="detail-table-wrapper">
                  <Table>
                    <tbody>
                      <tr>
                        <th className="sub">口座情報</th>
                        <th className="sub">支払方法</th>
                        <th className="sub">支払期日</th>
                        <th className="sub">支払額</th>
                        <th className="sub">仕入状況</th>
                        <th className="sub">メモ</th>
                        <th className="sub">削除</th>
                      </tr>
                    {this.state.pdata.length>0 && this.state.pdata.map((data,index)=> {
                      return <PaymentList data={data} index={index} key={index}/>
                    })}
                    </tbody>
                  </Table>
                </Col>
                </Row>
                <Container>
                  <Row>
                    <Col md="6"></Col>
                    {/* <Col md="6" className={___SUM_total_amt===___SUM_payment_amt?"off":"on"}>
                      <span className="red">※仕入対象見積合計と、支払額の合計が一致しません</span>
                    </Col> */}
                  </Row>
                  <Row>
                    <Col md="6" className="text-center">
                      <Button color="secondary" onClick={() => { this.props.history.push(this.props.location.transition_source) }}>一覧に戻る</Button>
                    </Col>
                    <Col md="6" className="text-center">
                      <ButtonWithRole
                        button_id="BTN_E1_02_02310"
                        color="secondary info"
                        onClick={() => {this.toggleSubRegistModal();}}
                        disabled={(___SUM_total_amt!==___SUM_payment_amt)}
                      >
                        仕入依頼
                      </ButtonWithRole>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Card>
          </Col>
        </div>
        <SummationSelectPopup ref={this.summation_select_popup} summationSelectedCallback={this.summationSelected} sdata = {this.state.sdata}/>
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">支払先情報</h5>
          </div>
          <ModalBody>
            <Row className="detail">
              <Col md="12" className="text-center">
                <Table>
                  <tbody>
                    <tr>
                      <CustomTd label='支払方法'
                        name='PAYMENT__payment_type'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputRadio
                            // disabled_options={this.state.adjustment_flag==true?"4":""}
                            options={cst_payment_type}
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                    {/** 2022-07-24 */}
                    {this.state.paymentData.errors.bank != "" && this.state.paymentData.errors.bank != undefined ? 
                    <tr>
                      <td ColSpan="2">
                      <div style={{color:"red"}}>{this.state.paymentData.errors.bank}</div>
                      </td>
                    </tr>
                    :null}
                    <tr>
                      <CustomTd label="支払口座"
                        name='PAYMENT__bank'
                        copy={false}
                        value={
                          <InputSelect
                            disabled={this.state.paymentData.values.payment_type != "0"}
                            options={this.supplierBankOptions()}
                            validateCallback={this.validateCallback} 
                          />
                        }
                      />
                    </tr>
                    {this.cellsSupplierBanks()}
                    <tr>
                      <CustomTd label='支払期日'
                        name='PAYMENT__payment_limit_date'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputDatetime
                          labelOn={false}
                          validateCallback={this.validateCallback}
                          validateType={'regist'}
                          timeFormat={false}
                        />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='支払額（今回）'
                        name='PAYMENT__payment_amt'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputNumber
                            unit='円' 
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                            size={12}
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='仕入依頼時のメモ'
                        name='PAYMENT__payment_request_memo'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputText multiline={true}
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='経理課への仕入メモ（仕入依頼時に入力）'
                        name='PAYMENT__payment_user_memo'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputText multiline={true}
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                  </tbody>
                </Table>
            </Col>
            <Col md="12" className="text-center">
               <Button color="info" 
                onClick={() => {
                  if (!this.state.regist_modal) {
                    return;
                  }
                  this.paymentSelected();
                  if (Object.keys(this.state.paymentData.errors).length===0){
                    this.toggleRegistModal();
                  }
                }} className="float-right">支払先追加</Button>
            </Col>
          </Row>
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.sub_regist_modal} toggle={this.toggleSubRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleSubRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">仕入依頼</h5>
          </div>
          <ModalBody>
            <p>仕入依頼をします。よろしいですか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSubRegistModal}>
              いいえ
            </Button>
            <Button color="info" onClick={()=>{this.regist()}}>
              はい
            </Button>
          </ModalFooter>
        </Modal> 
      </>
    );
  }
  supplierBankOptions () {
    return this.state.supplierBankList.map((bank, index)=>{
      let {
        id,
        supplier_bank,
        supplier_bank_branch,
        supplier_bank_account_number,
        supplier_bank_account_type,
        supplier_bank_account_kana,
      } = bank
      let account_type = cst_supplier_bank_account_type.filter(type=>type.value == supplier_bank_account_type)[0].label
      let label = supplier_bank + "銀行  " + supplier_bank_branch + " " + account_type + " " + supplier_bank_account_number + " " + supplier_bank_account_kana
      return {
        value: id,
        label: label
      }
    });
  }
  // 2022-07-27
  cellsSupplierBanks () {
  let {
    payment_bank,
    payment_bank_branch,
    payment_bank_account_kana,
    payment_bank_account_type,
    payment_bank_account_number
  } = this.state.paymentData.values
  let account_type = payment_bank_account_type != null && payment_bank_account_type != ""? cst_supplier_bank_account_type.filter(type=>type.value == payment_bank_account_type)[0].label : " "
  const selectableBankBranch = this.state.bankBranchList.filter(element=>element.bank_natural_id==this.state.paymentData.values.bank_natural_id)

  return (<>
      <tr>
        <CustomTd label='銀行名'
          name='PAYMENT__payment_bank'
          copy={false}
          rootData={this.state.paymentData}
          value={this.customFields(payment_bank && payment_bank.length>0? payment_bank + "銀行" : " ")}
        />
      </tr>
      <tr>
        <CustomTd label='支店名'
          name='PAYMENT__payment_bank_branch'
          copy={false}
          rootData={this.state.paymentData}
          value={this.customFields(payment_bank_branch && payment_bank_branch.length>0? payment_bank_branch : " ")}
        />
      </tr>
      <tr>
        <CustomTd label='口座名義（カナ）'
          name='PAYMENT__payment_bank_account_kana'
          copy={false}
          rootData={this.state.paymentData}
          value={this.customFields(payment_bank_account_kana && payment_bank_account_kana.length>0? payment_bank_account_kana : " ")}
        />
      </tr>
      <tr>
        <CustomTd label='口座種別'
          name='PAYMENT__payment_bank_account_kana'
          copy={false}
          rootData={this.state.paymentData}
          value={this.customFields(account_type)}
        />
      </tr>
      <tr>
        <CustomTd label='口座番号'
          name='PAYMENT__payment_bank_account_number'
          copy={false}
          rootData={this.state.paymentData}
          value={this.customFields(payment_bank_account_number && payment_bank_account_number.length>0? payment_bank_account_number : " ")}
        />
      </tr>
  </>);
  }
  customFields (value) {
    const align = {textAlign:"left"}
    return (<div style={align}>{value}</div>);
  }
}

export default List;
